export class LoginDto {
  username: string;
  password: string;
  account: string;

  constructor() {
  }
}
